// **********************************************************
// Tabs Slider
// **********************************************************

const tabsSlider = document.querySelectorAll('[data-slider="tabs-slider"]');

const tabsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 0,
  watchOverflow: true,
  freeMode: {
    momentum: false,
  },
  centerInsufficientSlides: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
};

tabsSlider.forEach((el) => {
  const parentElem = el.closest('.tabs-slider');
  const arrowLeft = parentElem.querySelector('.swiper-button-prev');
  const arrowRight = parentElem.querySelector('.swiper-button-next');

  tabsSliderOptions.navigation.prevEl = arrowLeft;
  tabsSliderOptions.navigation.nextEl = arrowRight;

  new Swiper(el, tabsSliderOptions);
});

// Tabs Control

const tabModule = document.querySelectorAll('[data-tab-parent]');

tabModule.forEach((element) => {
  const allTriggers = element.querySelectorAll('[data-tab-trigger]');
  const allContents = element.querySelectorAll('[data-tab-content]');

  allTriggers.forEach((trigger, index) => {
    trigger.addEventListener('click', () => {
      // Product Configuration Tabs
      if (element.classList.contains('layouts-module__configuration') && trigger.classList.contains('is-active')) {
        allTriggers.forEach((el) => el.classList.remove('is-active'));

        allContents.forEach((block) => {
          block.classList.remove('is-active');
          if (block.classList.contains('layouts-module__configuration-content--default')) {
            block.classList.add('is-active');
          }
        });

        return;
      }

      // Normal Tabs
      allTriggers.forEach((el) => el.classList.remove('is-active'));
      trigger.classList.add('is-active');

      allContents.forEach((block, blockIndex) => {
        block.scrollTo({ top: 0, behavior: 'smooth' });
        block.classList.toggle('is-active', blockIndex === index);
      });
    });
  });
});
